import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Link } from 'react-router-dom';
import styles from 'ui-components/Breadcrumbs.scss';

var DefaultDelimeter = function DefaultDelimeter() {
  return /*#__PURE__*/React__default.createElement("span", {
    className: styles.delimeter
  });
};
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _cn, _cn2;
  var className = _ref.className,
    root = _ref.root,
    current = _ref.current,
    links = _ref.links,
    _ref$Delimeter = _ref.Delimeter,
    Delimeter = _ref$Delimeter === void 0 ? DefaultDelimeter : _ref$Delimeter,
    variant = _ref.variant;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className, (_cn = {}, _cn[styles.hasVariant] = Boolean(variant), _cn), (_cn2 = {}, _cn2[styles[variant]] = Boolean(variant), _cn2))
  }, root !== null && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, root ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Link, {
    className: styles.link,
    to: root.url
  }, root.icon ? /*#__PURE__*/React__default.createElement(root.icon, null) : null, root.title ? root.title : null)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Link, {
    className: styles.link,
    to: t("BREADCRUMBS.HOME_URL")
  }, t("BREADCRUMBS.HOME")))), root !== null && /*#__PURE__*/React__default.createElement(Delimeter, null), links && links.map(function (l) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: l.pathname + (l.search || "")
    }, /*#__PURE__*/React__default.createElement(Link, {
      className: styles.link,
      to: {
        pathname: l.pathname,
        search: l.search,
        state: l.hint ? {
          hint: {
            type: "category",
            category: {
              name: l.hint.name
            }
          }
        } : {}
      }
    }, l.title), /*#__PURE__*/React__default.createElement(Delimeter, null));
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles.current
  }, current));
};

export { Breadcrumbs };
//# sourceMappingURL=index.js.map
